"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var util_1 = require("util");
/**************************************** PROJECT MODULES *****************************************/
var javelin_exports_1 = require("../../javelin-exports");
/******************************************** LOGGING *********************************************/
var shared_1 = require("mad-logs/lib/shared");
var log = shared_1.logFactory('data-manager.ts', shared_1.Styles.aquarium, util_1.inspect);
/********************************* EXPORT DATA WITH TYPES APPLIED *********************************/
exports.SchedulerManager = javelin_exports_1.javelin.data.util.manager.SchedulerManager;
// JVLN_CLASS_NAME goes right on the object - there's no prototype here
Object.defineProperty(exports.SchedulerManager, 'JVLN_CLASS_NAME', {
    enumerable: false,
    configurable: false,
    writable: false,
    value: 'SchedulerManager',
});
//# sourceMappingURL=scheduler-manager.js.map